import * as React from "react";
import { StyledStep } from "../../components/ReactTourSteps/ReactTourSteps.styles";

export const tourSteps = [
  {
    selector: ".step-1",
    content: () => (
      <StyledStep>
        <h1 className="step-title">My Child's Learning Style</h1>
        <p className="step-text">
          Here you will see the Performance Learning Score and description
          allocated for your child based on your Performance Learning answers.
        </p>
      </StyledStep>
    ),
    style: { background: "#2a2a2a" },
  },
  {
    selector: ".step-2",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Your Children</h1>
        <p className="step-text">
          Look here to see a quick view of the children you have registered to
          your Performance Learning Dashboard.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-3",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Add a Child</h1>
        <p className="step-text">
          Loving Performance Learning and want to give another child access to
          the great Performance Learning tools? Click here and I will take you
          through the steps to add them to your Dashboard.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-4",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Book a Call</h1>
        <p className="step-text">
          If you want to know more about your Performance Learning results, why
          not book a call with one of the team? You can do that here.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-5",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Results</h1>
        <p className="step-text">
          Ready to dig deeper into your Performance Learning results? Click here
          and I will take you to your results page.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-6",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Profile</h1>
        <p className="step-text">
          Click on your name and you can access your Performance Learning profile
          to update your details or logout.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
];



// WEBPACK FOOTER //
// ./src/pages/Assessments/ParentHomeTour.tsx